<!-- eslint-disable vue-a11y/click-events-have-key-events -->
<template>
  <SamMenu
    class="sam-datetimepicker"
    v-bind="menuProps"
    @open="onMenuOpen"
    @close="onMenuClose"
  >
    <template #activator="{ on }">
      <a
        :class="['sam-datetimepicker__menu-activator', { 'is-disabled': disabled }]"
        v-on="disabled ? {} : on"
        @click.prevent
      >
        <SamInput
          v-bind="inputProps"
          class="sam-datetimepicker__input"
          readonly
          :clearable="withClear"
          :disabled="disabled"
          :placeholder="placeholder"
          :value="displayDate"
          @clear="onInputClear"
        />
      </a>
    </template>

    <SamCalendar
      ref="calendar"
      v-bind="calendarBoundProps"
      :value="value"
      class="sam-datetimepicker__calendar"
      :only-date="onlyDate"
      :only-time="onlyTime"
      @change="onCalendarDateChange"
    />
  </SamMenu>
</template>

<script>
import SamMenu from '../SamMenu/SamMenu.vue';
import SamCalendar from '../SamCalendar/SamCalendar.vue';
import SamInput from '../SamInput/SamInput.vue';
import dateTimeMixin from '../../../mixins/dateTimeMixin';

export default {
  name: 'SamDateTimePicker',
  components: { SamInput, SamCalendar, SamMenu },
  mixins: [dateTimeMixin],
  props: {
    /**
     * Props to be bound to SamInput component. See SamInput component props.
     */
    inputProps: {
      type: Object,
      default: () => ({}),
    },
    /**
     * The Datepicker's input placeholder.
     */
    placeholder: {
      type: String,
      default: null,
    },
  },
  computed: {
    dateFormat() {
      if (this.displayDateFormat) return `${this.displayDateFormat}`;
      if (this.onlyDate || this.calendarProps?.onlyDate) return 'Y-m-d';
      if (this.onlyTime || this.calendarProps?.onlyTime) return 'H:i';
      return 'Y-m-d H:i';
    },
  },
};
</script>

<style scoped lang="scss">
.sam-datetimepicker::v-deep {
  width: 100%;

  &.sam-menu .menu__content {
    min-width: max-content;
    max-width: max-content;
    padding: 0;
  }

  .sam-datetimepicker__menu-activator {
    .sam-input__input,
    .sam-datetimepicker__input {
      cursor: pointer;
    }

    &.is-disabled {
      cursor: not-allowed;
    }
  }
}
</style>
